import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UserListComponent } from './components/user-list/user-list.component';
import { ManageUserComponent } from './components/manage-user/manage-user.component';
import { UserPageComponent } from './components/user-page/user-page.component';
import { RolesPermissionsComponent } from './components/roles-permissions/roles-permissions.component';
import { LoginCredentialsComponent } from './components/login-credentials/login-credentials.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { PrimengLibraryModule } from 'primeng-library';
import { UpdateUserCountComponent } from './components/update-user-count/update-user-count.component';
import { DeleteUserComponent } from './components/delete-user/delete-user.component';
import { UpgradeAccountComponent } from './components/upgrade-account/upgrade-account.component';
import { MenuModule } from 'primeng/menu';
import { PrimaryContactConfirmationComponent } from './components/primary-contact-confirmation/primary-contact-confirmation.component';

@NgModule({
  declarations: [
    UserListComponent,
    ManageUserComponent,
    UserPageComponent,
    RolesPermissionsComponent,
    LoginCredentialsComponent,
    UpdateUserCountComponent,
    DeleteUserComponent,
    UpgradeAccountComponent,
    PrimaryContactConfirmationComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatTabsModule,
    FormsModule,
    NgxPermissionsModule.forChild(),
    PrimengLibraryModule,
    MenuModule
  ],
  providers: [],
  exports: [UserListComponent, ManageUserComponent]
})

export class UserModule { }
